export default {
  dataConfigPurposes: (state) => state.dataConfigPurposes,
  dataConfigService: (state) => state.dataConfigService,
  dataConfigMcc: (state) => state.dataConfigMcc,
  dataConfigLocation: (state) => state.dataConfigLocation,
  dataConfigRegion: (state) => state.dataConfigRegion,
  dataDepositType: (state) => state.depositType,
  typeAddanceTimeKepping: (state) => state.typeAddanceTimeKepping,
  allConfig: (state) => state.allConfig
}
